<template>
  <div class="expired-offer">
    <h2 class="expired-offer__title">
      {{ $t('oldTranslations.modals.expiredOffer.title') }}
    </h2>
    <base-button
      type="red"
      with-shadow
      rounded="full"
      class="expired-offer__cta"
      @click="handleContinue"
    >
      {{ $t('oldTranslations.modals.expiredOffer.cta') }}
    </base-button>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['action']);
const { toggleComponent } = useModals();

function handleContinue() {
  toggleComponent();
  emit('action');
}

onBeforeUnmount(() => {
  emit('action');
});
</script>

<style lang="scss" scoped>
.expired-offer {
  padding: 24px 24px 48px;
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: calc(100% - 64px);

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &__title {
    text-align: center;
    font-family: $primary-fonts;;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 135%; /* 32.4px */
    margin-bottom: 24px;
  }

  &__cta {
    margin-top: 32px;
  }
}
</style>
